import entityContainerConnector from '~components/generic/entityContainerConnector';
import { Audio } from '~modules/audio/Audio';

export default entityContainerConnector(Audio);
